module.exports = __webpack_public_path__ + "c9f41e7660e038dc93e9a20e2e64872a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/authors/images/paper.png
// module id = 852
// module chunks = 3